import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalHeader, ModalBody, ModalFooter, Button } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import { useMutation } from '@apollo/client';
import * as Yup from 'yup';
import moment from 'moment';

import Input from '../../components/Input';
import NumberInput from '../../components/NumberInput';
import Select from '../../components/Select';
import { CREATE_COUPON } from './query';

const CreateCouponSchema = Yup.object().shape({
  code: Yup.string().required('Das ist ein Pflichtfeld'),
  packageStation: Yup.string().when('type', {
    is: 'INDIVIDUAL',
    then: Yup.string().required('Das ist ein Pflichtfeld'),
    otherwise: Yup.string(),
  }),
  description: Yup.string().required('Das ist ein Pflichtfeld'),
  validUntil: Yup.string().required('Das ist ein Pflichtfeld'),
  validUses: Yup.number().min(1, 'Eine Anwendung ist das Minimum').required('Das ist ein Pflichtfeld'),
  discountForOrderer: Yup.number().required('Das ist ein Pflichtfeld'),
});

const CreateCouponModal = ({ isOpen, onClose, refetch }) => {
  const [createCoupon] = useMutation(CREATE_COUPON);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Neuen Coupon erstellen</ModalHeader>

        <Formik
          initialValues={{
            code: '',
            type: 'GLOBAL',
            packageStation: '',
            description: '',
            validUntil: '',
            validUses: '',
            discountForOrderer: 3.99,
            rateForStation: 0.5,
          }}
          validationSchema={CreateCouponSchema}
          onSubmit={async ({ code, type, description, validUntil, validUses, discountForOrderer, packageStation, rateForStation }) => {
            await createCoupon({
              variables: {
                data: {
                  code,
                  type,
                  packageStations:
                    type === 'INDIVIDUAL'
                      ? {
                          connect: [
                            {
                              id: packageStation,
                            },
                          ],
                        }
                      : null,
                  description,
                  validUntil: moment(validUntil, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                  validUses: parseInt(validUses),
                  rateForStation: rateForStation * 100,
                  discountForOrderer: discountForOrderer * 100,
                },
              },
            });
            await refetch();
            onClose();
          }}>
          {({ values }) => (
            <Form>
              <ModalBody>
                <Input name="code" label="Coupon-Code" />
                <Select
                  name="type"
                  label="Generell oder Individuell?"
                  options={[
                    { label: 'Alle DropPoints', value: 'GLOBAL' },
                    { label: 'Ein DropPoint', value: 'INDIVIDUAL' },
                  ]}
                />
                {values.type === 'INDIVIDUAL' ? <Input name="packageStation" label="DropPoint-ID" /> : null}
                <Input name="description" label="Beschreibung" />
                <Input name="validUntil" placeholder="DD.MM.YYYY" label="Gültig bis" />
                <NumberInput name="validUses" type="number" label="Anwendungen" />
                <NumberInput name="rateForStation" precision={2} step={0.01} type="number" min={0} max={1.5} label="DropPoint Vergütung" />
                <NumberInput
                  name="discountForOrderer"
                  precision={2}
                  step={0.01}
                  type="number"
                  min={0}
                  max={3.99}
                  label="Finaler Besteller-Preis"
                />
              </ModalBody>

              <ModalFooter>
                <Button variant="ghost" size="sm" colorScheme="red" type="button" onClick={onClose}>
                  Schließen
                </Button>
                <Button ml="4" size="sm" colorScheme="brand" type="submit">
                  Speichern
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
};

export default CreateCouponModal;
